export function groupByLongestPrefix<T>(objects: T[], keySelector: (obj: T) => string) {
    const fullPrefixesGroup: Record<string, T[]> = {};

    for (const obj of objects) {
        const key = keySelector(obj);
        const parts = key.split('_');
        for (let i = parts.length; i >= 1; i--) {
            const prefix = parts.slice(0, i).join('_');
            if (!fullPrefixesGroup[prefix]) {
                fullPrefixesGroup[prefix] = [];
            }

            fullPrefixesGroup[prefix].push(obj);
        }
    }

    const singlesAndUniqueMultiples: Record<string, T[]> = JSON.parse(JSON.stringify(fullPrefixesGroup));
    for (const [key, value] of Object.entries(fullPrefixesGroup)) {
        if (value.length > 1) {
            for (const [key1, value1] of Object.entries(fullPrefixesGroup)) {
                if (key !== key1) {
                    const hasItem = value.some((item: any) => value1.includes(item));

                    if (key.length > key1.length && hasItem) {
                        delete singlesAndUniqueMultiples[key1];
                    }
                }
            }
        }
    }

    const noSinglesThatAreInMultiples: Record<string, T[]> = {};
    const moreThen2Keys = Object.keys(singlesAndUniqueMultiples).filter(key => singlesAndUniqueMultiples[key].length > 1);
    for (const key of moreThen2Keys) {
        for (const [key1] of Object.entries(singlesAndUniqueMultiples)) {
            if (key1.startsWith(key)) {
                if (key !== key1) {
                    noSinglesThatAreInMultiples[key] = singlesAndUniqueMultiples[key];
                }
            } else if (!moreThen2Keys.some(k => key1.startsWith(k))) {
                noSinglesThatAreInMultiples[key1] = singlesAndUniqueMultiples[key1];
            }
        }
    }

    const unique: Record<string, T[]> = JSON.parse(JSON.stringify(noSinglesThatAreInMultiples));
    for (const [key, value] of Object.entries(noSinglesThatAreInMultiples)) {
        if (value.length === 1) {
            const id = keySelector(value[0]);
            for (const [key1, values] of Object.entries(noSinglesThatAreInMultiples)) {
                if (key !== key1 && (key1.startsWith(key) || key.startsWith(key1))) {
                    if (key.length > key1.length) {
                        if (!values.find((item: any) => id === item)) {
                            delete unique[key1];
                        }
                    }
                }
            }
        }
    }

    return unique;
}
